<template>
  <div />
</template>

<script>
import { EventBus } from '@/lib/event-bus';

export default {
  name: 'Logout',
  created() {
    EventBus.$emit('logout');
  },
};
</script>
